import { createContext, useContext, useState } from "react";

const STORAGE_KEY = "bg_locale";

const pt = {
  enter: "Entrar",
  logout: "Sair",
  back: "Voltar",
  continue: "Continuar",
  confirm_booking: "Confirmar agendamento",
  booking_in_progress: "Agendando...",
  select_service: "Selecione um serviço",
  closed: "fechado",
  landing_overline: "Para barbeiros",
  landing_title: "Pare de fazer seu cliente esperar.",
  landing_sub: 'Enquanto você demora pra responder "quais horários tem hoje?" no WhatsApp, seu cliente já agendou na barbearia do lado, aquela que tem link de agendamento. Com o Barber Menu, ele marca sozinho em 30 segundos, sem criar conta.',
  landing_cta: "Criar minha página grátis",
  landing_cta_sub: "Leva menos de 1 minuto.",
  pain_title: "A verdade dura",
  pain1: "Cliente que espera resposta no WhatsApp",
  pain1_b: "desiste ou esquece de você",
  pain2: "Cada pausa no atendimento pra responder mensagem",
  pain2_b: "te custa tempo e dinheiro",
  pain3: "O concorrente com agenda online",
  pain3_b: "fica com o cliente que era seu",
  f1_t: "Cliente agenda sem criar conta",
  f1_d: "Nome e WhatsApp, pronto. Zero barreira entre ele e a sua cadeira.",
  f2_t: "Seu link trabalha enquanto você corta",
  f2_d: "No WhatsApp e no Instagram, recebendo agendamento até de madrugada.",
  f3_t: "Seus serviços, seus preços",
  f3_d: "Cadastre cortes, combos, duração e valores do seu jeito.",
  f4_t: "Agenda sob controle",
  f4_d: "Veja o dia, conclua ou cancele horários e bloqueie folgas.",
  f5_t: "Calculadora de lucro inteligente",
  f5_d: "Simule cortes, preços e despesas e veja seu lucro do mês na hora.",
  f6_t: "Ranking de clientes fiéis",
  f6_d: "Veja quem mais agenda e chame de volta quem sumiu, direto no WhatsApp.",
  plan_label: "Plano único",
  landing_price: "R$ 24,90",
  per_month: "/mês",
  plan_b1: "Agendamentos ilimitados",
  plan_b2: "Página personalizada com sua foto",
  plan_b3: "Agenda, bloqueios e relatório do dia",
  plan_b4: "Sem taxa por agendamento",
  plan_b5: "Cancele quando quiser, sem multa",
  plan_trial_note: "Você tem 10 dias grátis para testar",
  pricing_cta: "Começar agora",
  roi: "Um cliente a mais por semana já paga a assinatura.",
  roi_bold: "Quantos você perdeu esse mês?",
  login_title: "Entrar",
  login_sub: "Acesse o painel da sua barbearia com seu WhatsApp.",
  login_id_ph: "WhatsApp ou e-mail",
  password_ph: "Senha",
  logging_in: "Entrando...",
  no_account: "Ainda não tem conta?",
  create_page_link: "Crie sua página",
  login_error: "Erro ao entrar",
  reg_title: "Crie sua página",
  reg_sub: "Leva menos de 1 minuto. Sem cartão, sem complicação.",
  shop_label: "Nome da barbearia",
  shop_ph: "Ex: Barbearia do Zé",
  wa_label: "Seu WhatsApp",
  wa_ph: "(14) 99999-9999",
  wa_note: "Você entra no painel com ele. Sem e-mail, sem confirmação.",
  pwd_label: "Crie uma senha",
  pwd_ph: "Mínimo 6 caracteres",
  reg_btn: "Criar minha página",
  creating: "Criando...",
  have_account: "Já tem conta?",
  reg_success: "Conta criada! Sua página já está no ar.",
  reg_error: "Erro ao criar conta",
  warn_shop: "Informe o nome da barbearia",
  warn_wa: "Informe um WhatsApp válido",
  warn_pwd: "A senha precisa de pelo menos 6 caracteres",
  step1: "Passo 1",
  step2: "Passo 2",
  step3: "Passo 3",
  choose_service: "Escolha o serviço",
  choose_datetime: "Data e horário",
  your_data: "Seus dados",
  no_account_needed: "Sem cadastro, sem senha. Só o essencial.",
  name_label: "Nome completo",
  name_ph: "Como o barbeiro deve te chamar?",
  client_wa_note: "Usado apenas para você consultar ou cancelar o horário depois.",
  at: "às",
  with_word: "com",
  duration_pre: "Duração de",
  pay_at_shop: "Pagamento na barbearia",
  booked_title: "Agendado!",
  booked_sub: "seu horário está reservado.",
  code_label: "Código do agendamento",
  code_note: "Guarde este código para consultar ou cancelar.",
  new_booking: "Fazer outro agendamento",
  lookup_link: "Já agendou? Consultar meu horário",
  lookup_title: "Consultar agendamento",
  lookup_desc: "Informe o WhatsApp e o código recebidos na confirmação.",
  lookup_phone_ph: "WhatsApp usado no agendamento",
  lookup_code_ph: "Código (ex: BM-AB12)",
  search: "Buscar",
  searching: "Buscando...",
  status_confirmed: "Confirmado",
  status_completed: "Concluído",
  status_canceled: "Cancelado",
  cancel_booking: "Cancelar agendamento",
  lookup_not_found: "Agendamento não encontrado. Confira o WhatsApp e o código.",
  cancel_success: "Agendamento cancelado",
  cancel_error: "Não foi possível cancelar",
  paid_at_shop_suffix: "(pago na barbearia)",
  no_slots: "Sem horários disponíveis neste dia. Escolha outra data.",
  no_services_public: "Nenhum serviço disponível no momento. Fale com o barbeiro.",
  hours_title: "Horários de atendimento",
  page_by: "Agenda online por",
  blocked_title: "Agendamentos pausados",
  blocked_text: "Esta barbearia está com a página temporariamente indisponível. Fale diretamente com o barbeiro.",
  nf_title: "Página não encontrada",
  nf_text: "Confira o link com seu barbeiro.",
  load_error: "Não foi possível carregar as informações",
  pick_service: "Escolha um serviço para continuar",
  pick_datetime: "Escolha a data e o horário",
  enter_name: "Informe seu nome",
  enter_wa: "Informe um WhatsApp válido",
  book_error: "Erro ao agendar, tente novamente",
  slots_error: "Erro ao carregar horários",
  tab_agenda: "Agenda",
  tab_services: "Serviços",
  tab_profile: "Perfil",
  tab_billing: "Assinatura",
  tab_tools: "Ferramentas",
  tab_team: "Equipe",
  team_title: "Sua equipe",
  team_hint: "Cadastre os profissionais da barbearia. Ao agendar, o cliente poderá escolher com quem quer ser atendido.",
  team_name_ph: "Nome do profissional",
  team_add: "Adicionar",
  team_added: "Profissional adicionado",
  team_deleted: "Profissional removido",
  team_error: "Erro ao salvar. Tente novamente.",
  team_photo_btn: "Foto",
  team_empty: "Nenhum profissional cadastrado. Se você atende sozinho, pode deixar vazio.",
  prof_pick: "Escolha o profissional",
  prof_any: "Sem preferência",
  calc_title: "Calculadora de lucro",
  calc_hint: "Simule seus números. Nada é salvo.",
  calc_cuts_day: "Cortes por dia",
  calc_avg_price: "Preço médio (R$)",
  calc_days_week: "Dias trabalhados por semana",
  calc_expenses: "Despesas mensais (aluguel, produtos...)",
  calc_revenue: "Faturamento estimado/mês",
  calc_profit: "Lucro estimado/mês",
  month_title: "Seu mês até agora",
  month_bookings: "atendimentos",
  month_revenue: "receita estimada",
  top_title: "Clientes que mais marcam",
  top_empty: "Ainda sem agendamentos suficientes para o ranking.",
  top_visits: "visitas",
  top_visit: "visita",
  top_last: "último:",
  total_clients: "clientes únicos",
  trial_expired_title: "Período grátis encerrado",
  trial_expired_text: "Sua página de agendamento está pausada. Ative na aba Assinatura para voltar ao ar.",
  panel_error: "Erro ao carregar painel",
  link_copied: "Link copiado!",
  agenda_count: "Agendamentos",
  no_bookings: "Nenhum agendamento neste dia.",
  complete: "Concluir",
  cancel: "Cancelar",
  completed_ok: "Atendimento concluído",
  canceled_ok: "Agendamento cancelado",
  update_error: "Não foi possível atualizar",
  block_title: "Bloquear horário",
  block_reason_ph: "Motivo (opcional): almoço, folga...",
  block_btn: "Bloquear",
  block_ok: "Horário bloqueado",
  block_error: "Não foi possível bloquear",
  block_removed: "Bloqueio removido",
  block_remove_error: "Não foi possível remover",
  warn_block_time: "Escolha o horário do bloqueio",
  agenda_error: "Erro ao carregar agenda",
  svc_new: "Novo serviço",
  svc_edit: "Editar serviço",
  svc_name_ph: "Nome (ex: Corte Degrade)",
  svc_price_ph: "Preço em R$ (vazio = a combinar)",
  svc_add: "Adicionar",
  svc_save: "Salvar",
  svc_saving: "Salvando...",
  svc_added: "Serviço adicionado",
  svc_updated: "Serviço atualizado",
  svc_removed: "Serviço removido",
  svc_save_error: "Não foi possível salvar",
  svc_remove_error: "Não foi possível remover",
  svc_load_error: "Erro ao carregar serviços",
  svc_empty: "Nenhum serviço cadastrado. Adicione o primeiro acima.",
  import_toggle: "Já usava outra agenda online? Importar meus dados",
  import_hint: "Cole o link da sua página pública de agendamentos e trazemos seus serviços, preços e endereço automaticamente.",
  import_url_ph: "https://... (link do seu perfil)",
  import_btn: "Importar",
  import_working: "Importando...",
  import_success: "serviços importados! Revise e ajuste abaixo.",
  import_error: "Erro ao importar. Tente novamente.",
  cp_title: "Crie sua senha",
  cp_sub: "Por segurança, defina uma senha nova no seu primeiro acesso.",
  cp_password_ph: "Nova senha (mín. 6 caracteres)",
  cp_save: "Salvar e entrar",
  cp_success: "Senha definida! Bem-vindo ao Barber Menu.",
  cp_error: "Erro ao salvar. Tente novamente.",
  cp_too_short: "A senha precisa de pelo menos 6 caracteres",
  saving: "Salvando...",
  raffle_title: "Sorteio de clientes",
  raffle_hint: "Cada agendamento do mês (não cancelado) vale 1 chance. Quem vem mais, tem mais chances de ganhar.",
  raffle_btn: "Sortear agora",
  raffle_drawing: "Sorteando...",
  raffle_winner: "Ganhador(a)",
  raffle_chances: "chances no sorteio",
  raffle_empty: "Sem agendamentos neste mês para sortear.",
  raffle_history: "Últimos sorteios",
  raffle_wa: "Chamar no WhatsApp",
  raffle_error: "Erro ao sortear. Tente novamente.",
  deposit_title: "Sinal de reserva (opcional)",
  deposit_hint: "Cobre um adiantamento para garantir a vaga. O cliente vê sua chave ao agendar e envia o comprovante pelo seu WhatsApp.",
  deposit_amount_ph: "Valor do sinal (ex: 20)",
  deposit_key_ph: "Sua chave Pix",
  dep_card_title: "Sinal para garantir sua reserva",
  dep_card_hint: "Envie o comprovante pelo WhatsApp do barbeiro.",
  dep_copy: "Copiar",
  dep_copied: "Copiado!",
  dep_copy_error: "Não foi possível copiar",
  cancel_too_late: "O cancelamento só pode ser feito até 1 hora antes do horário.",
  warn_svc_name: "Informe o nome do serviço",
  prof_photo_change: "Trocar foto (opcional)",
  uploading: "Enviando...",
  photo_ok: "Foto atualizada",
  photo_error: "Erro ao enviar foto",
  prof_shop: "Nome da barbearia",
  prof_desc: "Descrição (opcional)",
  prof_desc_ph: "Conte um pouco sobre você e seu estilo de trabalho",
  prof_city: "Cidade",
  prof_address: "Endereço",
  prof_address_ph: "Rua, número, bairro",
  prof_hours: "Horários de atendimento",
  prof_banner: "Banner da página",
  prof_to: "às",
  prof_save: "Salvar perfil",
  prof_saving: "Salvando...",
  prof_saved: "Perfil salvo",
  prof_error: "Não foi possível salvar",
  bill_plan: "Plano Barber Menu",
  bill_active: "Assinatura ativa",
  bill_active_code: "Ativa por código",
  bill_trial_card: "Teste grátis (com cartão)",
  bill_past_due: "Pagamento pendente",
  bill_canceled: "Cancelada",
  bill_trial: "Período grátis",
  bill_paused: "Página pausada",
  trial_days_suffix: "dias grátis restantes",
  paid_days_note: "dias liberados pelo código",
  subscribe_trial: "Assinar agora (cobra só após o teste)",
  subscribe: "Assinar agora",
  subscribing: "Redirecionando...",
  bill_active_msg: "Cobrança mensal automática via Stripe. Para cancelar, fale com o suporte.",
  redeem_title: "Tem um código de resgate?",
  redeem_ph: "Ex: BM-XXXX-XXXX",
  redeem_btn: "Resgatar",
  redeeming: "Resgatando...",
  redeem_ok: "Código aplicado! Período liberado.",
  redeem_error: "Código inválido ou já utilizado",
  code_pay_note: "Para ativar ou renovar, compre seu código de 30 dias com o administrador.",
  py_pay_title: "Ative sua página",
  py_pay_alias_label: "Envie o pagamento para o alias:",
  py_pay_copy_alias: "Copiar alias",
  py_pay_alias_copied: "Alias copiado!",
  py_pay_whatsapp: "Comprar pelo WhatsApp",
  py_proof_upload: "Enviar comprovante",
  py_proof_uploading: "Enviando...",
  py_proof_sent: "Comprovante enviado! Vamos analisar e liberar seu acesso.",
  py_proof_error: "Erro ao enviar comprovante",
  py_proof_invalid: "Envie uma imagem ou PDF do comprovante (máx 8MB)",
  py_proof_pending: "Em análise",
  py_proof_approved: "Aprovado",
  py_proof_rejected: "Recusado",
  py_proofs_title: "Meus comprovantes",
  py_proof_hint: "Pagou? Envie o comprovante aqui para liberarmos seus 30 dias.",
  pix_btn: "Pagar com Pix",
  pix_generating: "Gerando QR Code...",
  pix_title: "Pix de",
  pix_scan: "Escaneie o QR Code ou copie o código abaixo:",
  pix_copy: "Copiar código Pix",
  pix_copied: "Código Pix copiado!",
  pix_waiting: "Aguardando confirmação do pagamento...",
  pix_paid: "Pagamento confirmado! 30 dias liberados.",
  pix_error: "Não foi possível gerar o Pix agora",
  pix_or_card: "ou assine com cartão (renovação automática)",
  pay_confirming: "Confirmando pagamento...",
  pay_wait: "Aguarde um instante.",
  pay_success: "Assinatura ativada!",
  pay_success_sub: "Sua página de agendamento está no ar. Bons cortes!",
  pay_go_panel: "Ir para o painel",
  pay_almost: "Quase lá",
  pay_almost_sub: "Estamos confirmando seu pagamento. Verifique o painel em alguns minutos.",
  pay_canceled: "Pagamento cancelado",
  pay_canceled_sub: "Sem problemas, você pode assinar quando quiser pelo painel.",
  pay_back: "Voltar ao painel",
  weekdays_full: ["Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado", "Domingo"],
  categories: ["Cortes", "Barbas", "Sobrancelhas", "Combos", "Outros"],
};

const es = {
  enter: "Ingresar",
  logout: "Salir",
  back: "Volver",
  continue: "Continuar",
  confirm_booking: "Confirmar reserva",
  booking_in_progress: "Reservando...",
  select_service: "Seleccioná un servicio",
  closed: "cerrado",
  landing_overline: "Para barberos",
  landing_title: "Dejá de hacer esperar a tu cliente.",
  landing_sub: 'Mientras demorás en responder "¿qué horarios tenés hoy?" en WhatsApp, tu cliente ya reservó en la barbería de al lado, esa que tiene link de reserva. Con Barber Menu, reserva solo en 30 segundos, sin crear cuenta.',
  landing_cta: "Crear mi página gratis",
  landing_cta_sub: "Lleva menos de 1 minuto.",
  pain_title: "La verdad dura",
  pain1: "El cliente que espera respuesta en WhatsApp",
  pain1_b: "desiste o se olvida de vos",
  pain2: "Cada pausa en la atención para responder mensajes",
  pain2_b: "te cuesta tiempo y dinero",
  pain3: "El competidor con agenda online",
  pain3_b: "se queda con el cliente que era tuyo",
  f1_t: "El cliente reserva sin crear cuenta",
  f1_d: "Nombre y WhatsApp, listo. Cero barrera entre él y tu silla.",
  f2_t: "Tu link trabaja mientras cortás",
  f2_d: "En WhatsApp e Instagram, recibiendo reservas hasta de madrugada.",
  f3_t: "Tus servicios, tus precios",
  f3_d: "Cargá cortes, combos, duración y valores a tu manera.",
  f4_t: "Agenda bajo control",
  f4_d: "Mirá el día, completá o cancelá horarios y bloqueá descansos.",
  f5_t: "Calculadora de ganancia inteligente",
  f5_d: "Simulá cortes, precios y gastos, y mirá tu ganancia del mes al instante.",
  f6_t: "Ranking de clientes fieles",
  f6_d: "Mirá quién reserva más y recuperá a los que desaparecieron, directo por WhatsApp.",
  plan_label: "Plan único",
  landing_price: "Gs 40.000",
  per_month: "/mes",
  plan_b1: "Reservas ilimitadas",
  plan_b2: "Página personalizada con tu foto",
  plan_b3: "Agenda, bloqueos y reporte del día",
  plan_b4: "Sin comisión por reserva",
  plan_b5: "Cancelás cuando quieras, sin multa",
  plan_trial_note: "Tenés 10 días gratis para probar",
  pricing_cta: "Empezar ahora",
  roi: "Un cliente más por semana ya paga la suscripción.",
  roi_bold: "¿Cuántos perdiste este mes?",
  login_title: "Ingresar",
  login_sub: "Accedé al panel de tu barbería con tu WhatsApp.",
  login_id_ph: "WhatsApp o e-mail",
  password_ph: "Contraseña",
  logging_in: "Ingresando...",
  no_account: "¿Todavía no tenés cuenta?",
  create_page_link: "Creá tu página",
  login_error: "Error al ingresar",
  reg_title: "Creá tu página",
  reg_sub: "Lleva menos de 1 minuto. Sin tarjeta, sin complicación.",
  shop_label: "Nombre de la barbería",
  shop_ph: "Ej: Barbería del José",
  wa_label: "Tu WhatsApp",
  wa_ph: "0991 234 567",
  wa_note: "Ingresás al panel con él. Sin e-mail, sin confirmación.",
  pwd_label: "Creá una contraseña",
  pwd_ph: "Mínimo 6 caracteres",
  reg_btn: "Crear mi página",
  creating: "Creando...",
  have_account: "¿Ya tenés cuenta?",
  reg_success: "¡Cuenta creada! Tu página ya está en el aire.",
  reg_error: "Error al crear la cuenta",
  warn_shop: "Ingresá el nombre de la barbería",
  warn_wa: "Ingresá un WhatsApp válido",
  warn_pwd: "La contraseña necesita al menos 6 caracteres",
  step1: "Paso 1",
  step2: "Paso 2",
  step3: "Paso 3",
  choose_service: "Elegí el servicio",
  choose_datetime: "Fecha y horario",
  your_data: "Tus datos",
  no_account_needed: "Sin registro, sin contraseña. Solo lo esencial.",
  name_label: "Nombre completo",
  name_ph: "¿Cómo debe llamarte el barbero?",
  client_wa_note: "Solo se usa para que consultes o canceles tu horario después.",
  at: "a las",
  with_word: "con",
  duration_pre: "Duración de",
  pay_at_shop: "Pago en la barbería",
  booked_title: "¡Reservado!",
  booked_sub: "tu horario quedó reservado.",
  code_label: "Código de la reserva",
  code_note: "Guardá este código para consultar o cancelar.",
  new_booking: "Hacer otra reserva",
  lookup_link: "¿Ya reservaste? Consultar mi horario",
  lookup_title: "Consultar reserva",
  lookup_desc: "Ingresá el WhatsApp y el código recibidos en la confirmación.",
  lookup_phone_ph: "WhatsApp usado en la reserva",
  lookup_code_ph: "Código (ej: BM-AB12)",
  search: "Buscar",
  searching: "Buscando...",
  status_confirmed: "Confirmada",
  status_completed: "Completada",
  status_canceled: "Cancelada",
  cancel_booking: "Cancelar reserva",
  lookup_not_found: "Reserva no encontrada. Verificá el WhatsApp y el código.",
  cancel_success: "Reserva cancelada",
  cancel_error: "No se pudo cancelar",
  paid_at_shop_suffix: "(se paga en la barbería)",
  no_slots: "No hay horarios disponibles este día. Elegí otra fecha.",
  no_services_public: "No hay servicios disponibles por el momento. Hablá con el barbero.",
  hours_title: "Horarios de atención",
  page_by: "Agenda online por",
  blocked_title: "Reservas pausadas",
  blocked_text: "Esta barbería tiene la página temporalmente no disponible. Hablá directamente con el barbero.",
  nf_title: "Página no encontrada",
  nf_text: "Verificá el link con tu barbero.",
  load_error: "No se pudieron cargar los datos",
  pick_service: "Elegí un servicio para continuar",
  pick_datetime: "Elegí la fecha y el horario",
  enter_name: "Ingresá tu nombre",
  enter_wa: "Ingresá un WhatsApp válido",
  book_error: "Error al reservar, intentá de nuevo",
  slots_error: "Error al cargar los horarios",
  tab_agenda: "Agenda",
  tab_services: "Servicios",
  tab_profile: "Perfil",
  tab_billing: "Suscripción",
  tab_tools: "Herramientas",
  tab_team: "Equipo",
  team_title: "Tu equipo",
  team_hint: "Registrá los profesionales de la barbería. Al reservar, el cliente podrá elegir con quién atenderse.",
  team_name_ph: "Nombre del profesional",
  team_add: "Agregar",
  team_added: "Profesional agregado",
  team_deleted: "Profesional eliminado",
  team_error: "Error al guardar. Intentá de nuevo.",
  team_photo_btn: "Foto",
  team_empty: "Ningún profesional registrado. Si atendés solo, podés dejarlo vacío.",
  prof_pick: "Elegí el profesional",
  prof_any: "Sin preferencia",
  calc_title: "Calculadora de ganancia",
  calc_hint: "Simulá tus números. Nada se guarda.",
  calc_cuts_day: "Cortes por día",
  calc_avg_price: "Precio promedio (Gs)",
  calc_days_week: "Días trabajados por semana",
  calc_expenses: "Gastos mensuales (alquiler, productos...)",
  calc_revenue: "Facturación estimada/mes",
  calc_profit: "Ganancia estimada/mes",
  month_title: "Tu mes hasta ahora",
  month_bookings: "atenciones",
  month_revenue: "ingreso estimado",
  top_title: "Clientes que más reservan",
  top_empty: "Todavía no hay reservas suficientes para el ranking.",
  top_visits: "visitas",
  top_visit: "visita",
  top_last: "último:",
  total_clients: "clientes únicos",
  trial_expired_title: "Período gratis terminado",
  trial_expired_text: "Tu página de reservas está pausada. Activála en la pestaña Suscripción.",
  panel_error: "Error al cargar el panel",
  link_copied: "¡Link copiado!",
  agenda_count: "Reservas",
  no_bookings: "No hay reservas este día.",
  complete: "Completar",
  cancel: "Cancelar",
  completed_ok: "Atención completada",
  canceled_ok: "Reserva cancelada",
  update_error: "No se pudo actualizar",
  block_title: "Bloquear horario",
  block_reason_ph: "Motivo (opcional): almuerzo, descanso...",
  block_btn: "Bloquear",
  block_ok: "Horario bloqueado",
  block_error: "No se pudo bloquear",
  block_removed: "Bloqueo eliminado",
  block_remove_error: "No se pudo eliminar",
  warn_block_time: "Elegí el horario del bloqueo",
  agenda_error: "Error al cargar la agenda",
  svc_new: "Nuevo servicio",
  svc_edit: "Editar servicio",
  svc_name_ph: "Nombre (ej: Corte Degradado)",
  svc_price_ph: "Precio en Gs (vacío = a convenir)",
  svc_add: "Agregar",
  svc_save: "Guardar",
  svc_saving: "Guardando...",
  svc_added: "Servicio agregado",
  svc_updated: "Servicio actualizado",
  svc_removed: "Servicio eliminado",
  svc_save_error: "No se pudo guardar",
  svc_remove_error: "No se pudo eliminar",
  svc_load_error: "Error al cargar servicios",
  svc_empty: "Ningún servicio registrado. Agregá el primero arriba.",
  import_toggle: "¿Ya usabas otra agenda online? Importar mis datos",
  import_hint: "Pegá el link de tu página pública de reservas y traemos tus servicios, precios y dirección automáticamente.",
  import_url_ph: "https://... (link de tu perfil)",
  import_btn: "Importar",
  import_working: "Importando...",
  import_success: "servicios importados! Revisá y ajustá abajo.",
  import_error: "Error al importar. Intentá de nuevo.",
  cp_title: "Creá tu contraseña",
  cp_sub: "Por seguridad, definí una contraseña nueva en tu primer acceso.",
  cp_password_ph: "Nueva contraseña (mín. 6 caracteres)",
  cp_save: "Guardar y entrar",
  cp_success: "¡Contraseña definida! Bienvenido a Barber Menu.",
  cp_error: "Error al guardar. Intentá de nuevo.",
  cp_too_short: "La contraseña necesita al menos 6 caracteres",
  saving: "Guardando...",
  raffle_title: "Sorteo de clientes",
  raffle_hint: "Cada reserva del mes (no cancelada) vale 1 chance. Quien viene más, tiene más chances de ganar.",
  raffle_btn: "Sortear ahora",
  raffle_drawing: "Sorteando...",
  raffle_winner: "Ganador(a)",
  raffle_chances: "chances en el sorteo",
  raffle_empty: "No hay reservas este mes para sortear.",
  raffle_history: "Últimos sorteos",
  raffle_wa: "Escribir por WhatsApp",
  raffle_error: "Error al sortear. Intentá de nuevo.",
  deposit_title: "Seña de reserva (opcional)",
  deposit_hint: "Cobrá un adelanto para asegurar el turno. El cliente ve tu alias al reservar y envía el comprobante por tu WhatsApp.",
  deposit_amount_ph: "Monto de la seña (ej: 50000)",
  deposit_key_ph: "Tu alias de transferencia",
  dep_card_title: "Seña para asegurar tu reserva",
  dep_card_hint: "Enviá el comprobante por el WhatsApp del barbero.",
  dep_copy: "Copiar",
  dep_copied: "¡Copiado!",
  dep_copy_error: "No se pudo copiar",
  cancel_too_late: "La cancelación solo puede hacerse hasta 1 hora antes del horario.",
  warn_svc_name: "Ingresá el nombre del servicio",
  prof_photo_change: "Cambiar foto (opcional)",
  uploading: "Subiendo...",
  photo_ok: "Foto actualizada",
  photo_error: "Error al subir la foto",
  prof_shop: "Nombre de la barbería",
  prof_desc: "Descripción (opcional)",
  prof_desc_ph: "Contá un poco sobre vos y tu estilo de trabajo",
  prof_city: "Ciudad",
  prof_address: "Dirección",
  prof_address_ph: "Calle, número, barrio",
  prof_hours: "Horarios de atención",
  prof_banner: "Banner de la página",
  prof_to: "a",
  prof_save: "Guardar perfil",
  prof_saving: "Guardando...",
  prof_saved: "Perfil guardado",
  prof_error: "No se pudo guardar",
  bill_plan: "Plan Barber Menu",
  bill_active: "Suscripción activa",
  bill_active_code: "Activa por código",
  bill_trial_card: "Prueba gratis (con tarjeta)",
  bill_past_due: "Pago pendiente",
  bill_canceled: "Cancelada",
  bill_trial: "Período gratis",
  bill_paused: "Página pausada",
  trial_days_suffix: "días gratis restantes",
  paid_days_note: "días liberados por el código",
  subscribe_trial: "Suscribirme ahora (cobra solo después de la prueba)",
  subscribe: "Suscribirme ahora",
  subscribing: "Redirigiendo...",
  bill_active_msg: "Cobro mensual automático vía Stripe. Para cancelar, hablá con soporte.",
  redeem_title: "¿Tenés un código de canje?",
  redeem_ph: "Ej: BM-XXXX-XXXX",
  redeem_btn: "Canjear",
  redeeming: "Canjeando...",
  redeem_ok: "¡Código aplicado! Período liberado.",
  redeem_error: "Código inválido o ya utilizado",
  code_pay_note: "Para activar o renovar, comprá tu código de 30 días con el administrador.",
  py_pay_title: "Activá tu página",
  py_pay_alias_label: "Enviá el pago al alias:",
  py_pay_copy_alias: "Copiar alias",
  py_pay_alias_copied: "¡Alias copiado!",
  py_pay_whatsapp: "Comprar por WhatsApp",
  py_proof_upload: "Enviar comprobante",
  py_proof_uploading: "Subiendo...",
  py_proof_sent: "¡Comprobante enviado! Lo revisamos y liberamos tu acceso.",
  py_proof_error: "Error al subir el comprobante",
  py_proof_invalid: "Subí una imagen o PDF del comprobante (máx 8MB)",
  py_proof_pending: "En revisión",
  py_proof_approved: "Aprobado",
  py_proof_rejected: "Rechazado",
  py_proofs_title: "Mis comprobantes",
  py_proof_hint: "¿Pagaste? Subí el comprobante acá para liberar tus 30 días.",
  pix_btn: "Pagar con Pix",
  pix_generating: "Generando QR...",
  pix_title: "Pix de",
  pix_scan: "Escaneá el QR o copiá el código:",
  pix_copy: "Copiar código Pix",
  pix_copied: "¡Código Pix copiado!",
  pix_waiting: "Esperando la confirmación del pago...",
  pix_paid: "¡Pago confirmado! 30 días liberados.",
  pix_error: "No se pudo generar el Pix ahora",
  pix_or_card: "o suscribite con tarjeta (renovación automática)",
  pay_confirming: "Confirmando pago...",
  pay_wait: "Esperá un instante.",
  pay_success: "¡Suscripción activada!",
  pay_success_sub: "Tu página de reservas está en el aire. ¡Buenos cortes!",
  pay_go_panel: "Ir al panel",
  pay_almost: "Casi listo",
  pay_almost_sub: "Estamos confirmando tu pago. Verificá el panel en unos minutos.",
  pay_canceled: "Pago cancelado",
  pay_canceled_sub: "Sin problema, podés suscribirte cuando quieras desde el panel.",
  pay_back: "Volver al panel",
  weekdays_full: ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"],
  categories: ["Cortes", "Barbas", "Cejas", "Combos", "Otros"],
};

const dicts = { pt, es };

const LocaleCtx = createContext(null);

export function LocaleProvider({ children }) {
  const [locale, setLocaleState] = useState(() => localStorage.getItem(STORAGE_KEY) || "pt");

  const setLocale = (l) => {
    localStorage.setItem(STORAGE_KEY, l);
    setLocaleState(l);
  };

  const t = (key) => dicts[locale]?.[key] ?? pt[key] ?? key;
  const intlLocale = locale === "es" ? "es-PY" : "pt-BR";

  return (
    <LocaleCtx.Provider value={{ locale, setLocale, t, intlLocale }}>
      {children}
    </LocaleCtx.Provider>
  );
}

export function useLocale() {
  return useContext(LocaleCtx);
}
